import { createSlice } from '@reduxjs/toolkit';
import { UserEntity } from '@interpals/api-web';

import { logout } from 'redux/auth/actions';

import { clearViewedUsers, getViewedUsers, setViewedLastFetched } from './actions';

export interface ViewedState {
    data?: UserEntity[];
    lastFetchTimestamp?: number;
}

const initialState: ViewedState = {};

const viewedSlice = createSlice({
    name: 'viewed',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getViewedUsers.fulfilled, (state, { payload }) => {
            state.data = payload;
        });

        builder.addCase(setViewedLastFetched, (state, { payload: lastFetched }) => {
            state.lastFetchTimestamp = lastFetched;
        });

        builder.addCase(logout.fulfilled, () => {
            return initialState;
        });

        builder.addCase(clearViewedUsers, () => {
            return initialState;
        });
    },
});

export default viewedSlice.reducer;
